import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-organization-permissions-form',
  templateUrl: './organization-permissions-form.component.html',
  styleUrls: ['./organization-permissions-form.component.scss'],
  standalone: false
})
export class OrganizationPermissionsFormComponent implements OnInit {
  @Input() form!: UntypedFormGroup;

  constructor() {}

  ngOnInit() {}
}
